import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/mobile_area',
    name: 'mobile_area',
    meta: { title: '携帯キャリアエリアマップ統合版', desc: '携帯キャリア（ドコモ、au、ソフトバンク、楽天モバイル、UQ、Y!モバイル）のエリアマップを重ねて表示できます。' },
    component: () => import('../views/MobileArea.vue')
  },
  {
    path: '/rakuten_own_area_map',
    name: 'rakuten_own_area_map',
    meta: { title: '楽天モバイル - 自社回線エリア更新履歴（マップ）', desc: '楽天モバイルの自社回線エリアの更新履歴をマップで確認できます。<br>更新日を選択するとマップに差分が表示されます。' },
    component: () => import('../views/RakutenOwnAreaMapOnly.vue')
  },
  {
    path: '/rakuten_own_area_map_only',
    name: 'rakuten_own_area_map_only',
    meta: { title: '楽天モバイル - 自社回線エリア更新履歴（マップ）', desc: '楽天モバイルの自社回線エリアの更新履歴をマップで確認できます。<br>更新日を選択するとマップに差分が表示されます。' },
    component: () => import('../views/RakutenOwnAreaMapOnly.vue')
  },
  {
    path: '*',
    name: '404',
    component: () => import('../views/404.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
